import { Lock } from 'lucide-react';

/** A line under the header saying why the page cannot be edited. */
export function LockedBanner({ hint }: { hint: string }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 11.5,
        color: 'var(--nb-muted)',
        padding: '0 2px',
      }}
    >
      <Lock size={12} aria-hidden="true" />
      {hint}
    </div>
  );
}
